export default {"src":"/_next/static/media/backIcon1.06bd33ad.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};